import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import Select from "react-select";

function FieldFilters({
  businessList,
  selectedBusinessList,
  farmList,
  selectedFarmList,
  searchValue,
  HandleBusinessChange,
  HandleFarmChange,
  handleSearchValue,
}) {
  return (
    <div className="field-filters">
      <Row>
        <Form.Group as={Col} controlId="FormBusinessList" md={3}>
          <Select
            name="businessList"
            isMulti
            options={businessList}
            value={selectedBusinessList}
            className="basic-multi-select"
            onChange={HandleBusinessChange}
            placeholder="Select Business"
          />
        </Form.Group>
        <Form.Group as={Col} controlId="FormFarmList" md={3}>
          <Select
            name="farmList"
            isMulti
            options={farmList}
            value={selectedFarmList}
            className="basic-multi-select"
            onChange={HandleFarmChange}
            placeholder="Select Farms"
          />
        </Form.Group>
        <Form.Group as={Col} md={2} />
        <Form.Group as={Col} controlId="FormSearch" md={4}>
          <Form.Control
            type="text"
            defaultValue={searchValue}
            name="searchValue"
            onChange={handleSearchValue}
            placeholder="Search"
            className="form-control form-control-lg me-2"
          />
        </Form.Group>
      </Row>
    </div>
  );
}

export default FieldFilters;
